import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-worklog-legend',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorklogLegendComponent {
  @HostBinding('class.single-color')
  @Input() singleColor: boolean;
  @Input() showOnlyPaidLeaves = false;
  // Timeline report: show the Meeting Time legend and the updated Leave Time
  // color (STAFF-145177). Off by default for other reports.
  @HostBinding('class.timeline-colors')
  @Input() showMeetingTime = false;
}
